require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/status-builder/components/09518674bfc51d6c16334b2c1558599b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function(pageData, value) {
  	const OLD_JIRA_ISSUE_URL = 'https://bugs.backendless.com/browse/'
  	const NEW_JIRA_ISSUE_URL = 'https://backendless.atlassian.net/browse/'

  	const OLD_JIRA_TICKET_CODE = 'BKNDLSS'

  	const buildHyperLink = (text, url) => `<a href="${ url }" target="_blank">${ text }</a>`
  	const wrapInDiv = text => `<div>${ text }</div>`

  	const enrichedStatus = value.replace(/([A-Za-z]+-\d+)/g, (match, p1) => {
  	  const url = match.startsWith(OLD_JIRA_TICKET_CODE)
  	    ? `${ OLD_JIRA_ISSUE_URL }${ match }`
  	    : `${ NEW_JIRA_ISSUE_URL }${ match }`

  	  return buildHyperLink(match, url)
  	})

  	const textWithNewlines = enrichedStatus.split('\n').map(wrapInDiv).join('');

  	pageData.enrichedStatus = textWithNewlines
  })(___arguments.context.pageData, ___arguments.value);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/status-builder/components/fd2d5b086cf59183c2f41b032f1d265d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (String('STATUS ') + String((await (async function() {
	const date = new Date()

	const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits for the day
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
	const year = date.getFullYear();

	return `${day}/${month}/${year}`;

})())))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	const date = new Date()

  	const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits for the day
  	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  	const year = date.getFullYear();

  	navigator.clipboard.writeText(`STATUS [${day}/${month}/${year}]`);

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/status-builder/components/b79cc6670cbd0496016b9e9529fb4ed2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'enrichedStatus')) ? (getObjectProperty(___arguments.context.pageData, 'enrichedStatus')) : 'The result will be here')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/status-builder/components/c0f43ae26b38acfd458217cca8661cb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('mailto:team@backendlessmail.com', true, ({ [`subject`]: ['Status ','[',((new Date()).toLocaleDateString()),']'].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/status-builder/components/f6c7bcbd21263543cda8ccc539bdaade/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	navigator.clipboard.writeText("team@backendlessmail.com")
  })();

  },
  /* handler:onClick */
  /* content */
}))

